export default __webpack_public_path__ + "static/media/aromativ.71ddb6e0.png";